import React from 'react';

export default function Legal() {
  return (
    <div className="min-h-screen bg-black text-white pt-24">
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold mb-8">Mentions légales</h1>

        <div className="prose prose-invert max-w-none">
          <h2 className="text-2xl font-semibold mb-4">Informations légales</h2>
          <p className="mb-6">
            Le site que vous consultez actuellement est la propriété de :
          </p>

          <div className="mb-8">
            <p>KEROS Management LTD</p>
            <p>Pod 2, The Old Station House</p>
            <p>15a main street, Blackrock, Co Dublin</p>
            <p>A94 T8P8, Ireland</p>
            <p>Le directeur de la publication est : T. Poujade</p>
            <p>Ce site est hébergé par la société : Netlify</p>
          </div>

          <h2 className="text-2xl font-semibold mb-4">Liens vers d'autres sites</h2>
          <p className="mb-8">
            Le site propose des liens vers des sites tiers. Ces liens sont établis avec les sites concernés à un moment où KEROS Management LTD a pu juger opportun de le faire, compte tenu des contenus et services de ces sites. KEROS Management LTD ne pourra être tenu responsable du contenu de ces sites et de l’usage qui pourra en être fait par les utilisateurs.
          </p>

          <h2 className="text-2xl font-semibold mb-4">Propriété Intellectuelle</h2>
          <p className="mb-8">
            L’accès au site vous confère un droit d’usage privé et non exclusif. Tous les articles, photographies et autres documents présents sont la propriété de KEROS Management LTD. Toute utilisation frauduleuse est interdite. KEROS Management LTD se réserve le droit d’engager des poursuites.
          </p>

          <h2 className="text-2xl font-semibold mb-4">Indisponibilité du site</h2>
          <p className="mb-8">
            KEROS Management LTD s’engage à assurer l’accessibilité du site. Toutefois, elle ne pourra être tenue responsable en cas d’indisponibilité pour quelque cause que ce soit.
          </p>

          <h2 className="text-2xl font-semibold mb-4">Conditions générales de vente</h2>
          <p className="italic mb-4">Édition du 7 janvier 2022</p>

          <div className="space-y-8">
            <section>
              <h3 className="text-xl font-semibold mb-3">1. PRÉSENTATION</h3>
              <p>KEROS Management LTD, société à responsabilité limitée immatriculée à Dublin, représentée par M. Thibault Poujade.</p>
              <p>Le siège de KEROS Management est situé en Irlande :</p>
              <p>Pod 2, The Old Station House</p>
              <p>15a main street, Blackrock, Co Dublin</p>
              <p>A94 T8P8, Ireland</p>


<div className="mt-4">
  <p>
   Les présentes conditions générales de vente s’appliquent à tous nos devis, propositions commerciales et factures. Toute dérogation nécessiterait un accord préalable écrit de KEROS Management LTD.
  </p>
</div>
            </section>

            {/* Add other sections if needed */}
          </div>
        </div>
      </div>
    </div>
  );
}



